module.exports = __webpack_public_path__ + "static/media/MapGpsTerritory.37eea786.svg";